import { createSlice } from "@reduxjs/toolkit";

const verifyDecks = (loaded) => {
    const decks = [];

    if (Array.isArray(loaded) && loaded.length === 5 && loaded[0].name && Array.isArray(loaded[0].arcanaIds)) {
        // remove useless property
        if (loaded[0].checkEvents && Array.isArray(loaded[0].checkEvents)) {
            loaded.forEach((e) => delete e.checkEvents);
        }
        return loaded;
    } else {
        for (let i = 0; i < 5; i++) {
            decks.push({
                name: `프리셋 ${i + 1}`,
                arcanaIds: [],
            });
        }
    }

    return decks;
    // if (loaded.length === 0 || Array.isArray(loaded[0])) {
    // }
};

const loadDecksFromStorage = () => {
    const localString = localStorage.getItem("saved_decks");
    let decks;

    if (localString) {
        try {
            const loaded = JSON.parse(localString);
            decks = verifyDecks(loaded);
        } catch (e) {
            decks = verifyDecks();
        }
    } else {
        decks = verifyDecks();
    }

    return decks;
};

const decks = loadDecksFromStorage();

const deckSlice = createSlice({
    name: "decks",
    initialState: {
        decks,
        selectedIndex: 0,
    },
    reducers: {
        changeDeckName: (state, action) => {
            const name = action.payload;
            state.decks[state.selectedIndex].name = name;

            localStorage.setItem("saved_decks", JSON.stringify(state.decks));
        },
        toNextDeck: (state) => {
            if (state.selectedIndex < 4) {
                state.selectedIndex++;
            }
        },
        toPrevDeck: (state) => {
            if (state.selectedIndex > 0) {
                state.selectedIndex--;
            }
        },
        toggleArcana: (state, action) => {
            if (!action.payload) return;

            if (state.decks[state.selectedIndex].arcanaIds.includes(action.payload.id)) {
                state.decks[state.selectedIndex].arcanaIds = state.decks[state.selectedIndex].arcanaIds.filter(
                    (id) => id !== action.payload.id,
                );
            } else if (state.decks[state.selectedIndex].arcanaIds.length < 5) {
                state.decks[state.selectedIndex].arcanaIds.push(action.payload.id);
            }

            localStorage.setItem("saved_decks", JSON.stringify(state.decks));
        },
    },
});

export const { changeDeckName, toNextDeck, toPrevDeck, toggleArcana } = deckSlice.actions;

export default deckSlice.reducer;
